import { withStyles } from '@material-ui/core';
import Detail from './common/Detail';
import Value from './common/Value';
import ShipmentBadgeList from './common/ShipmentBadgeList';
import HazmatPlacardDetail from './HazmatPlacardDetail';

const styles = () => ({
  container: {
    margin: '16px 0px'
  },
  driverName: {
    margin: '8px 0px'
  },
  detailsContainer: {
    display: 'flex'
  }
});

const ShipmentDetails = ({
  classes,
  proData,
  packageCode,
  isPickupPro = false
}) => {
  return (
    <div className={classes.container}>
      <div className={classes.detailsContainer}>
        <Value value={`PRO #${proData.proId}`} />
        <HazmatPlacardDetail placards={proData.hazmatInfo ?? []} />
      </div>
      <ShipmentBadgeList
        pieces={proData.pieces}
        weight={proData.weight}
        pkgType={packageCode}
        hu={proData.hu}
        stc={proData.stc}
        isPickupPro={isPickupPro}
      />
      {!isPickupPro && (
        <div className={classes.detailsContainer}>
          <Detail
            label="Is driver allowed inside to complete delivery?"
            value={proData.isDriverAllowedInside ? 'Yes' : 'No'}
          />
        </div>
      )}
    </div>
  );
};

export default withStyles(styles)(ShipmentDetails);
